var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"h-100 text-center d-flex justify-content-center"},[_c('b-spinner',{attrs:{"label":"Spinning"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }